<template>
	<control-button class="del-button" :useConfirm="useConfirm" :comfirmMessage="comfirmMessage"
		:comfirmOkText="comfirmOkText" :comfirmCancelText="comfirmCancelText" @buttonClick="buttonClick">
		<i v-if="icon" class="el-icon-delete del-button-icon"></i>
		<slot></slot>
	</control-button>
</template>

<script>
	import controlButton from "@/components/controlButton.vue"
	import {defineComponent} from "vue"
	
	export default defineComponent({
		name:"delBorder",
		components: {
			controlButton
		},
		props: {
			useConfirm: {
				type: Boolean,
				default: false
			},
			icon: {
				type: Boolean,
				default: true
			},
			comfirmMessage: {
				type: String,
				default: "这是一段内容确定删除吗？"
			},
			comfirmOkText: {
				type: String,
				default: "好的"
			},
			comfirmCancelText: {
				type: String,
				default: "不用了"
			}
		},
		emits:["buttonClick"],
		setup(props, {emit}){
			let methods = {
				buttonClick() {
					emit("buttonClick")
				}
			}
			
			return {
				...methods
			}
		}
	})
</script>

<style lang="scss" scoped="scoped">
	@import "~@/assets/styles/_handle.scss";
	
	.del-button{
		@include font_color("del-button-font-color");
		display: flex;
		align-items: center;
		align-content: center;
		justify-content: center;
		border: 0 !important;
		i{
				font-size: 25px!important;
			}
	}
</style>
